import numbersAPI from "@/api/numbers";
import moment from 'moment';

const state = () => ({

  options: {
    filters: {}
  },

  numberTransfersConfig: {
    paginationCount: 0,
    paginationLimit: 50,
    paginationPage: 1,
    status: ["PORTING","READY_TO_PORT"],
    portKind: [],
    productStatus: [],
    automatedOrderStatus: []
  },

  numberTransfers: [],                                                       
  numberTransfersLoading: true,
  numberTransfersError: [],

  nonGeoNumber: {},
  translateNumberTo: {},                                                       
  translateNumberToLoading: false,
  translateNumberToError: null,

});

const mutations = {
  UPDATE_NUMBER_TRANSFERS_PAGINATION(state, payload) {
    state.numberTransfersConfig.paginationLimit = (payload.itemsPerPage!==undefined)?payload.itemsPerPage:state.numberTransfersConfig.paginationLimit;
    state.numberTransfersConfig.paginationPage = (payload.page)?payload.page:state.numberTransfersConfig.paginationPage;
    state.numberTransfersConfig.status = (payload.status!==undefined)?payload.status:state.numberTransfersConfig.status;
    state.numberTransfersConfig.portKind = (payload.portKind!==undefined)?payload.portKind:state.numberTransfersConfig.portKind;
    state.numberTransfersConfig.productStatus = (payload.productStatus!==undefined)?payload.productStatus:state.numberTransfersConfig.productStatus;
    state.numberTransfersConfig.automatedOrderStatus = payload.automatedOrderStatus !== undefined ? payload.automatedOrderStatus : state.numberTransfersConfig.automatedOrderStatus;
    state.numberTransfersConfig.sortBy = (payload.sortBy!==undefined)?payload.sortBy:state.numberTransfersConfig.sortBy;
    state.numberTransfersConfig.sortDesc = (payload.sortDesc!==undefined)?payload.sortDesc:state.numberTransfersConfig.sortDesc;
  },
  
  SET_NUMBER_TRANSFERS(state, payload) {
    state.numberTransfers = payload.data;
    state.numberTransfersConfig.paginationCount = parseInt(payload.headers['pagination-count']);
    state.numberTransfersConfig.paginationLimit = parseInt(payload.headers['pagination-limit']);
    state.numberTransfersConfig.paginationPage = parseInt(payload.headers['pagination-page']);
    state.numberTransfersLoading = false;
  },

  SET_NUMBER_TRANSFERS_LOADING(state) {
    state.numberTransfersLoading = true;
  },

  SET_NUMBER_TRANSFERS_ERROR(state, payload) {
    state.numberTransfersLoading = false;
    state.numberTransfersError = payload;
  },

  TRANSLATE_NUMBER_TO_BEGIN(state) {
    state.translateNumberToError = null;
    state.translateNumberToLoading = true;
  },
  TRANSLATE_NUMBER_TO_SUCCESS(state,data) {
    state.translateNumberTo = data;
    state.translateNumberToLoading = false;
  },
  TRANSLATE_NUMBER_TO_FAILED(state, payload) {
    state.translateNumberToLoading = false;
    state.translateNumberToError = payload;
  },
  SET_NON_GEO_NUMBER(state, obj) {
    state.nonGeoNumber = obj;
  },

  SET_FILTER_NUMBER_TRANSFERS(state, payload) {
    state.numberTransfersLoading = false;
    state.options.filters.kind = payload.kind;
    state.options.filters.voidLead = payload.voidLead;
    state.numberTransfersConfig.paginationPage = payload.page ? payload.page : state.dailyConfig.paginationPage;
  },
};

const actions = {

  async updateNumberTransfersPagination({ commit, dispatch }, payload) {
    await commit("UPDATE_NUMBER_TRANSFERS_PAGINATION", payload);
    dispatch("loadNumberTransfers");
  },

  async loadNumberTransfers({ state, commit }) {
    try {
      commit("SET_NUMBER_TRANSFERS_LOADING");
      let data = await numbersAPI.loadNumberTransfers(state.numberTransfersConfig);
      commit("SET_NUMBER_TRANSFERS", data);
    } catch(err) {
      commit("SET_NUMBER_TRANSFERS_ERROR", err);
    }
  },

  async translateNumber({ commit, dispatch },{nonGeoNumId,translateToId,product_id}) {
    commit("TRANSLATE_NUMBER_TO_BEGIN");
    try {
      const data = await numbersAPI.translateNumberTo(nonGeoNumId,translateToId);
      dispatch("alerts/setAlert", {type: "success",message: `Non geographic number successfully translated!`}, { root: true });
      dispatch("products/fetchProductNumbers", product_id, { root: true });
      commit("TRANSLATE_NUMBER_TO_SUCCESS", data);
    } catch(err) {
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
      commit("TRANSLATE_NUMBER_TO_FAILED", err);
    }
  },

};

const getters = {
  getNumberTransfersConfigs: (state) => state.numberTransfersConfig,
  getNumberTransfers: state => state.numberTransfers,
  getNumberTransfersLoading: state => state.numberTransfersLoading,
  
  getNonGeoNumber: state => state.nonGeoNumber,
  getTranslateNumberTo: state => state.translateNumberTo,
  getTranslateNumberToError: state => state.translateNumberToError,
  getTranslateNumberToLoading: state => state.translateNumberToLoading,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
